/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";
import FontAwesome from 'react-fontawesome';

import ReviewForm from './ReviewForm';
import Badge from './Badge';
import { DetailRating, ratingFields } from './ReviewForm';
import { colorForRating, borderColorForRating } from './PercentBar';
import './ReviewItem.css';

import {
  updateReview,
} from '../../actions';


export class PercentBar extends Component {
  render() {
    let percent = this.props.percent;
    let color = colorForRating(percent);
    let borderColor = borderColorForRating(percent);

    let containerStyle = {};
    let barStyle = { width: percent + '%' };

    if (!this.props.gray) {
      containerStyle.borderColor = borderColor;
      barStyle.background = color;
    } else {
      // barStyle.background = 'rgba(0,0,0,' + ((percent + 50) / 300) + ')';
    }

    return (
      <div className={cx('PercentBar', { slim: this.props.slim, gray: this.props.gray })}>
        <div className="percent" style={containerStyle}>
          <div className="percent-number">{percent}/100</div>
          <div className="percent-bar" style={barStyle}></div>
        </div>
      </div>
    );
  }
}


class ReviewItem extends Component {

  state = {};

  renderByLine() {
    if (this.props.hideByLine) return;
    let review = this.props.review;
    if (!review || !review.profile) return;
    let numEscapes = review.escapeCount;
    return (
      <div className="by-line">
        <Badge profile={review.profile} />
      </div>
    );
  }

  // <Link to={'/p/' + review.profile.username}><b>{review.username}</b> {!!numEscapes && <span>({numEscapes} escape{numEscapes == 1 ? '' : 's'})</span>}</Link>

  renderStars() {
    if (this.props.noBar) return;
    let review = this.props.review;
    return <PercentBar percent={review.percent} />;
  }

  renderDetailRatings() {
    if (this.props.noDetails) return;
    let review = this.props.review;

    let ratingNodes = [];
    for (let rf of ratingFields) {
      let node = <DetailRating
                   key={rf}
                   data={review}
                   ratingField={rf}
                   noLong
                   noEmpty
                 />;
      ratingNodes.push(node);
    }

    if (ratingNodes.length == 0) {
      return;
    }

    return (
      <div className="detail-ratings">
        {ratingNodes}
      </div>
    )
  }

  saveReview(e, values) {
    this.props.updateReview(this.props.review.id, values)
      .then(resp => {
        if (resp.error) return;
        this.closeEdit();
      });
  }

  closeEdit() {
    this.setState({ editing: false });
  }

  renderEditReview() {
    let review = this.props.review;
    let user = this.props.user;
    if (!user) return;
    let profile = user.profile;
    if (!profile) return;
    if (profile.username != review.username) return;

    let copy;
    let bsStyle;
    if (review.body) {
      copy = 'Edit Review';
      bsStyle = 'default';
    } else {
      copy = 'Finish Review';
      bsStyle = 'default';
    }

    return (
      <div>
        {!this.props.noButton && !this.state.editing && <div className="edit-button">
          <Button bsStyle={bsStyle} onClick={() => this.setState({ editing: true })}>{copy}</Button>
        </div>}

        <Modal show={this.state.editing}>
          <Modal.Header closeButton onHide={() => this.closeEdit()}>
            <Modal.Title>Edit Escape</Modal.Title>
          </Modal.Header>
          <ReviewForm
            modal={true}
            values={review}
            errors={this.props.errors.review}
            onSubmit={(e, values) => this.saveReview(e, values)}
            onCancel={() => this.closeEdit()}
            buttonText="Save"
            cancelText="Cancel"
            room={review.room}
          />
        </Modal>

      </div>
    );
  }

  renderSpoilers() {
    let review = this.props.review;
    if (!review || !review.bodySpoilers) return;

    return (
      <div className="body-spoilers-wrapper">
        {!this.state.showSpoilers && <div className="spoiler-warning">
         This review has a spoiler section. Reveal it at your own risk! <Button bsSize="xs" onClick={() => this.setState({ showSpoilers: true })}>Show SPOILERS</Button>
         </div>}
         {this.state.showSpoilers && <div className="body-spoilers">{review.bodySpoilers}</div>}
      </div>
    );
  }

  render() {
    let review = this.props.review;
    let body;
    if (!this.props.noBody) {
      body = (
        <div>
          {!this.props.noPercentBar && this.renderStars()}
          {!this.props.noByLine && this.renderByLine()}
          {this.renderDetailRatings()}
          {review.body && <div className="body">{review.body}</div>}
          {this.renderSpoilers()}
        </div>
      );
    }
    return (
      <div className="ReviewItem">
        {body}
        {this.renderEditReview()}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    updateReview,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReviewItem);



/** WEBPACK FOOTER **
 ** ./src/components/partials/ReviewItem.js
 **/